module.exports = __webpack_public_path__ + "assets/c0ff73d42b12ee124e6fc8d87a003b9b.mp4";